<template>
  <Button @click="isSearchOpened = true" class="w-full font-normal" variant="outline">
    <SearchIcon class="mr-1.5 h-4 w-4 flex-none" />
    <span class="text-muted-foreground whitespace-nowrap">Search...</span>
    <span class="ml-auto hidden flex-none pl-3 text-xs font-medium md:block">
      <span v-if="isMacintosh()"><span class="font-bold">⌘</span> + K</span>
      <span v-else class="rounded border p-1">ctrl + K</span>
    </span>
  </Button>
</template>

<script setup lang="ts">
import { SearchIcon } from '@lucide/vue';
import { storeToRefs } from 'pinia';
import { onMounted, onUnmounted } from 'vue';

import { useAppStore } from '@/app/store';
import { isMacintosh } from '@/shared/lib/misc';
import { Button } from '@/shared/ui/button';

const { isSearchOpened } = storeToRefs(useAppStore());

const openSearchByKeyboard = (e: KeyboardEvent) => {
  if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
    e.preventDefault();
    isSearchOpened.value = true;
  }
};

onMounted(() => {
  window.addEventListener('keydown', openSearchByKeyboard);
});

onUnmounted(() => {
  window.removeEventListener('keydown', openSearchByKeyboard);
});
</script>
